export class AuditLogExtendedDataMpa {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequestId",
            "baseName": "mpaRequestId",
            "type": "string",
            "format": ""
        },
        {
            "name": "intercepted",
            "baseName": "intercepted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "executed",
            "baseName": "executed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mpaPolicyIds",
            "baseName": "mpaPolicyIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogExtendedDataMpa.attributeTypeMap;
    }
    constructor() {
    }
}
